import React from "react";
import Page from "../../organisms/Page";
import { BreadCrumbItem } from "../../organisms/HeaderSection";
import LoadingScreen from "../../organisms/LoadingScreen";
import ServerErrorModal from "../../organisms/ServerErrorModal";
import {
  useGetGruposUsuarios,
  useListarUsuarios,
} from "../../../services/seguridadServicios";
import ListaUsuarios from "./ListaUsuarios";

const breadCrumbs: BreadCrumbItem[] = [
  { path: "/", label: "Inicio" },
  { path: "/seguridad", label: "Seguridad" },
  {
    path: "/seguridad/administrar-usuarios",
    label: "Administrar usuarios",
    isActive: true,
  },
];

function AdministrarUsuarios() {
  const {
    data: usuarios,
    isLoading: usuariosIsLoading,
    error: usuariosError,
  } = useListarUsuarios();
  const {
    data: grupos,
    isLoading: gruposIsLoading,
    error: gruposError,
  } = useGetGruposUsuarios();

  if (usuariosError || gruposError) {
    return <ServerErrorModal />;
  }

  if (usuariosIsLoading || gruposIsLoading) {
    return <LoadingScreen isLoading={true} />;
  }

  return (
    <Page
      title="Administrar usuarios"
      description="Visualización de usuarios y asignación a grupos."
      breadCrumbs={breadCrumbs}
    >
      <ListaUsuarios usuarios={usuarios || []} grupos={grupos || []} />
    </Page>
  );
}

export default AdministrarUsuarios;
